import React from 'react';
import PropTypes from 'prop-types';

import {
    Heading,
    Image,
    Text,
    TextButton,
} from '@zillow/constellation';

import zGuaranteeIcon from 'app/shared/images/z-guarantee.svg';

import {
    StyledUpsell,
} from './StyledComponents';

const LeadGuaranteeBanner = (props) => {
    const {
        actionLabel,
        actionPath,
        actionTarget,
        body,
        heading,
        iconWidthPX,
        paddingXLOnDesktop,
    } = props;

    return (
        <StyledUpsell
            className="LeadGuaranteeBanner"
            actionButton={(
                <TextButton
                    as="a"
                    href={actionPath}
                    target={actionTarget}
                >
                    {actionLabel}
                </TextButton>
            )}
            closeable={false}
            heading={<Heading level={6}>{heading}</Heading>}
            headingPlacement="headline"
            body={(<Text>{body}</Text>)}
            background="backgroundBlue"
            media={<Image alt="" src={zGuaranteeIcon} />}
            mediaQuery={
                {
                    xs: { showBody: true },
                    md: { showBody: true },
                }
            }
            iconWidthPX={iconWidthPX}
            paddingXLOnDesktop={paddingXLOnDesktop}
        />
    );
};

LeadGuaranteeBanner.propTypes = {
    actionLabel: PropTypes.string,
    actionPath: PropTypes.string,
    actionTarget: PropTypes.string,
    body: PropTypes.string.isRequired,
    heading: PropTypes.string,
    iconWidthPX: PropTypes.string,
    paddingXLOnDesktop: PropTypes.bool,
};
LeadGuaranteeBanner.defaultProps = {
    actionLabel: '',
    actionPath: '#',
    actionTarget: '_self',
    heading: '',
    iconWidthPX: '44px',
    paddingXLOnDesktop: false,
};

export default LeadGuaranteeBanner;
